/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceServiceAccountSummaryRequest {
    getFixupPrototypeFunction() { return ComplianceServiceAccountSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceServiceAccountSummaryRequest>): ComplianceServiceAccountSummaryRequest {
        let obj = Object.assign(new ComplianceServiceAccountSummaryRequest(), model);
        ComplianceServiceAccountSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceServiceAccountSummaryRequest>): ComplianceServiceAccountSummaryRequest {
        if (!model) return null;
        return ComplianceServiceAccountSummaryRequest.newInstance(<ComplianceServiceAccountSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceServiceAccountSummaryRequest) {
        if (!obj) return;

        models.ComplianceServiceAccountSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceServiceAccountSummaryRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceServiceAccountSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Query based on Tenant IDs, Cloud Providers, Cloud Account Ids and Compliance URIs
     */
    filters: models.QueryOperator;

}
